import { Tooltip, TooltipProps } from "@fluentui/react-components";
import { ReactNode, useEffect, useRef, useState } from "react";

const TooltipWithMount = ({
	content,
	relationship,
	children,
	showDelay = 100,
	...props
}: TooltipProps & { children: ReactNode }) => {
	const [mountNode, setMountNode] = useState<HTMLElement | null>(null);
	const ref = useRef(null);

	useEffect(() => {
		if (ref.current) {
			setMountNode(ref.current);
		}
	}, []);

	return (
		<>
			<Tooltip
				mountNode={mountNode}
				content={content}
				relationship={relationship}
				showDelay={showDelay}
				{...props}
			>
				{children}
			</Tooltip>
			<div ref={ref} />
		</>
	);
};

export default TooltipWithMount;
